export default __webpack_public_path__ + "static/media/E-2BD main cover.60e93fe6.jpg";